import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Link } from "react-router"
import { Dropdown, Modal } from 'react-bootstrap'
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import DebtorsSmsModal from 'pages/parts/DebtorsSmsModal'
import { hasPermission } from 'helpers/permissions'

import { GET, POST, httpOk } from 'helpers/api'
import {
	findKeyFromArrayByValue, formatMoney, regexPhoneNumber, returnSign,
	buildCashAccountSelectOptions, getAccountSelectProps
} from 'helpers/helpers'
import { renderSortIndicator } from 'helpers/tableSortIndicator'

function Index() {
	const { t } = useTranslation()
	const reduxAccount = useSelector(state => state.account)

	const [data, setData] = useState([])
	const [poses, setPoses] = useState([])
	const [accounts, setAccounts] = useState([])
	const [modalPayment, setModalPayment] = useState(false)
	const [modalOpeningDebt, setModalOpeningDebt] = useState(false)
	const [openingDebt, setOpeningDebt] = useState({})
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({
		pos_id: reduxAccount.pos_id,
		order_by: null,
		sort: 'asc',
	})
	const [pagination, setPagination] = useState({
		url: '/report-clients',
		response: null
	})
	const [selectedItem, setSelectedItem] = useState({})
	// Точка, по которой загружен список: долг клиента хранится по точкам,
	// и гасить его надо там же, а не на точке из незаприменённого фильтра
	const [listPosId, setListPosId] = useState(reduxAccount.pos_id)
	const [showDebtorsSms, setShowDebtorsSms] = useState(false)

	async function searchWithFilter(nextFilterData = filterData) {
		var filterUrl = "/report-clients"
		var urlParams = ""
		const filterDataCopy = { ...nextFilterData }
		checkFilter(filterDataCopy)

		if (filterDataCopy.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterDataCopy.pos_id
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page
		if (filterDataCopy.order_by) {
			urlParams += returnSign(urlParams) + 'order_by=' + filterDataCopy.order_by
			urlParams += returnSign(urlParams) + 'sort=' + (filterDataCopy.sort === 'desc' ? 'desc' : 'asc')
		}

		if (`/report-clients${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
			setListPosId(filterDataCopy.pos_id || reduxAccount.pos_id)
		}

		setDropdownIsOpen(false)
	}

	// Погашение долга: клиент вернул деньги на сейф / банк (касса — только на кассе)
	async function payment(e) {
		e.preventDefault()

		const response = await POST('/clients-payment', {
			pos_id: selectedItem.pos_id,
			client_id: selectedItem.client_id,
			account_chef_id: selectedItem.account_chef_id,
			amount: selectedItem.amount,
			note: selectedItem.note,
		}, { loader: true })

		if (httpOk(response)) {
			toggleModalPayment(false)
			searchWithFilter()
		}
	}

	function toggleModalPayment(bool = false, item = null) {
		if (bool) {
			const debt = Number(item.balance) < 0 ? Math.abs(Number(item.balance)) : 0
			setSelectedItem({
				pos_id: listPosId,
				client_id: item.client_id,
				client_name: item.first_name,
				client_phone: item.phone1,
				debt: debt,
				amount: debt > 0 ? String(debt) : '',
				account_chef_id: null,
				note: '',
			})
		}

		setModalPayment(bool)
	}

	// Начальный долг: перенос старого долга без чека и без движения денег
	function toggleModalOpeningDebt(bool = false, item = {}) {
		if (bool) {
			setOpeningDebt({
				pos_id: filterData.pos_id || reduxAccount.pos_id,
				client_id: item.client_id,
				client_name: item.first_name,
				client_phone: item.phone1,
				amount: '',
				note: '',
			})
		}
		setModalOpeningDebt(bool)
	}

	async function saveOpeningDebt(e) {
		e.preventDefault()

		const response = await POST('/clients-opening-debt', {
			pos_id: openingDebt.pos_id,
			client_id: openingDebt.client_id,
			amount: openingDebt.amount,
			note: openingDebt.note,
		}, { loader: true })

		if (httpOk(response)) {
			toggleModalOpeningDebt(false)
			searchWithFilter()
		}
	}

	function resetFilter() {
		const nextFilterData = {
			pos_id: null,
			search: '',
			page: null,
			order_by: null,
			sort: 'asc',
		}
		setFilterData(nextFilterData)
		searchWithFilter(nextFilterData)
	}

	function checkFilter(currentFilterData = filterData) {
		if (
			currentFilterData.pos_id === null &&
			currentFilterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function paginate(page) {
		const nextFilterData = { ...filterData, 'page': page }
		setFilterData(nextFilterData)
		searchWithFilter(nextFilterData)
	}

	function handleSortColumn(column) {
		const nextFilterData = {
			...filterData,
			order_by: column,
			sort: filterData.order_by === column && filterData.sort === 'asc' ? 'desc' : 'asc',
			page: null,
		}
		setFilterData(nextFilterData)
		searchWithFilter(nextFilterData)
	}

	async function getPoses() {
		const response = await GET('/helper/poses')
		if (httpOk(response)) setPoses(response.data)
	}

	async function getAccounts() {
		const response = await GET('/helper/accounts')
		if (httpOk(response)) setAccounts(response.data)
	}

	useEffect(() => {
		getPoses()
		getAccounts()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const accountChefOptions = buildCashAccountSelectOptions(accounts)

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center h-100">
					{t('clients')} [{pagination?.response?.total}]
				</h4>
				{hasPermission('sending_sms') &&
					<button className="btn-rounded btn btn-outline-primary" onClick={() => setShowDebtorsSms(true)}>
						<i className="uil-comment-alt-message me-1" />{t('sms_debtors_button')}
					</button>
				}
			</div>

			<DebtorsSmsModal
				show={showDebtorsSms}
				onHide={() => setShowDebtorsSms(false)}
				counterparty="client"
				posId={listPosId}
			/>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex gap-2">
							<FilterSearch
								filterData={filterData}
								setFilterData={setFilterData}
								onSearchChange={(search) => {
									const nextFilterData = { ...filterData, search, page: null }
									setFilterData(nextFilterData)
									searchWithFilter(nextFilterData)
								}}>
							</FilterSearch>
							<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
								<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
									{t('filter')}
								</Dropdown.Toggle>

								<Dropdown.Menu className="dropdown-filter">
									<div className="row">
										<div className="form-group col-md-6">
											<label>{t('pos')}</label>
											<Select
												options={poses}
												value={poses.find(option => option.id === filterData.pos_id) || ''}
												onChange={(option) => setFilterData({ ...filterData, 'pos_id': option.id })}
												placeholder=""
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-md-12">
											<div className="d-flex justify-content-end gap-2">
												<button className="btn btn-secondary"
													onClick={() => setDropdownIsOpen(false)}>
													{t('cancel')}
												</button>
												<button className="btn btn-primary"
													onClick={() => searchWithFilter({ ...filterData, page: null })}>
													{t('apply')}
												</button>
											</div>
										</div>
									</div>
								</Dropdown.Menu>
							</Dropdown>
						</div>
						<div className="d-flex gap-2">
							<div className="vertical-center">
								<h4><b>{t('amount')}</b>:</h4>
							</div>
							<div className="vertical-center">
								<h5 className="text-end">
									<span className={`${data.total_amount >= 0 ? 'text-success' : 'text-danger'}`}>
										{formatMoney(data.total_amount)}
									</span>
								</h5>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{filterData.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b>
										{findKeyFromArrayByValue(poses, 'id', filterData.pos_id, 'name')}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>
									{t('reset')}
								</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered table-hover mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th
										style={{ 'width': '20%' }}
										className="th-sortable user-select-none"
										onClick={() => handleSortColumn('name')}
										title={t('sort_by')}>
										<div className="d-flex align-items-center justify-content-between gap-2 pe-1">
											<span>{t('client')}</span>
											{renderSortIndicator('name', filterData)}
										</div>
									</th>
									<th style={{ 'width': '10%' }}>{t("phone")}</th>
									<th style={{ 'width': '60%' }}></th>
									<th
										style={{ 'width': '10%' }}
										className="text-end th-sortable user-select-none"
										onClick={() => handleSortColumn('balance')}
										title={t('sort_by')}>
										<div className="d-flex align-items-center justify-content-end gap-2">
											<span>{t("debt")}</span>
											{renderSortIndicator('balance', filterData)}
										</div>
									</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr className="tr-middle" key={index}>
										<td className="text-center">{item.row_number}</td>
										<td className="td-ellipsis">
											<Link className="text-primary cursor table-first-column-clickable"
												to={`/report-clients/debts/${item.client_id}`}>
												{item.first_name}
											</Link>
										</td>
										<td className="text-nowrap">{regexPhoneNumber(item.phone1)}</td>
										<td></td>
										<td className="text-end text-nowrap">
											<div className={item.balance >= 0 ? 'text-success' : 'text-danger'}>
												<span>{formatMoney(item.balance)}</span>
											</div>
										</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														{Number(item.balance) < 0 &&
															<div className="table-dropdown-item"
																onClick={() => toggleModalPayment(true, item)}>
																<i className="uil uil-transaction"></i>
																{t('debt_repayment')}
															</div>
														}
														<div className="table-dropdown-item"
															onClick={() => toggleModalOpeningDebt(true, item)}>
															<i className="uil uil-history"></i>
															{t('opening_debt')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}

					{/* MODAL PAYMENT */}
					<Modal show={modalPayment} animation={false} centered
						backdrop="static"
						onHide={() => toggleModalPayment(false)}>
						<Modal.Header closeButton>
							<Modal.Title>{t('debt_repayment')}</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<form onSubmit={payment} autoComplete="off">
								<div className="form-group">
									<label>{t('client')}</label>
									<input type="text" className="form-control" readOnly tabIndex="-1"
										value={`${selectedItem.client_name ?? ''} ${regexPhoneNumber(selectedItem.client_phone)}`.trim()} />
								</div>
								<div className="form-group">
									<label>{t('operation_account')}<span className="required-mark">*</span></label>
									<Select
										isClearable
										{...getAccountSelectProps(t)}
										options={accountChefOptions}
										value={accountChefOptions.find(option => option.id === selectedItem.account_chef_id) || null}
										onChange={(option) => setSelectedItem({ ...selectedItem, 'account_chef_id': option ? option.id : null })}
									/>
								</div>
								<div className="form-group">
									<label>{t('amount')}<span className="required-mark">*</span></label>
									<input type="text" className="form-control" name="amount"
										value={selectedItem.amount ? formatMoney(selectedItem.amount) : ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'amount': e.target.value.replace(/[^0-9.]/g, '') })} />
									<div className={`small mt-1 ${Number(selectedItem.amount) > Number(selectedItem.debt) ? 'text-danger' : 'text-muted'}`}>
										{t('debt')}: {formatMoney(selectedItem.debt)}
									</div>
								</div>
								<div className="form-group">
									<label>{t('note')}</label>
									<input type="text" className="form-control" name="note" maxLength={255}
										value={selectedItem.note ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })} />
								</div>
								<div className="text-muted small">{t('debt_repayment_hint')}</div>
								<div className="d-flex gap-2 w-100 mt-3">
									<button type="button" className="btn btn-outline-warning w-100"
										onClick={() => toggleModalPayment(false)} tabIndex="-1">{t('cancel')}</button>
									<button type="submit" className="btn btn-primary w-100"
										disabled={
											!selectedItem.account_chef_id ||
											!(Number(selectedItem.amount) > 0) ||
											Number(selectedItem.amount) > Number(selectedItem.debt)
										}>
										{t('save')}
									</button>
								</div>
							</form>
						</Modal.Body>
					</Modal>
					{/* MODAL PAYMENT */}
				</div>
			</div>

			{/* MODAL OPENING DEBT */}
			<Modal show={modalOpeningDebt} animation={false} centered
				backdrop="static"
				dialogClassName="update-modal-width"
				onHide={() => toggleModalOpeningDebt(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('opening_debt')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={saveOpeningDebt} autoComplete="off">
						<div className="d-flex gap-2">
							<div className="form-group w-100">
								<label>{t('client')}</label>
								<input type="text" className="form-control" disabled
									value={openingDebt.client_name ?? ''} />
							</div>
							<div className="form-group w-100">
								<label>{t('phone')}</label>
								<input type="text" className="form-control" disabled
									value={regexPhoneNumber(openingDebt.client_phone)} />
							</div>
						</div>
						<div className="form-group">
							<label>{t('amount')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="amount" autoFocus
								value={openingDebt.amount ? formatMoney(openingDebt.amount) : ''}
								onChange={(e) => setOpeningDebt({ ...openingDebt, 'amount': e.target.value.replace(/[^0-9.]/g, '') })} />
						</div>
						<div className="form-group">
							<label>{t('note')}</label>
							<input type="text" className="form-control" name="note" maxLength={255}
								value={openingDebt.note ?? ''}
								onChange={(e) => setOpeningDebt({ ...openingDebt, 'note': e.target.value })} />
						</div>
						<div className="text-muted small">{t('opening_debt_hint')}</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalOpeningDebt(false)} tabIndex="-1">{t('cancel')}</button>
							<button type="submit" className="btn btn-primary w-100"
								disabled={!openingDebt.pos_id || !openingDebt.client_id || !(Number(openingDebt.amount) > 0)}>
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL OPENING DEBT */}
		</>
	)
}

export default Index
